<template>
  <report-page
    :title="name"
    :data-to-send="dataToSend"
    :buttons-disabled="buttonsDisabled"
    :history-filter="historyFilter"
    :selectedWorkspaceUUID="selectedWorkspace"
  >
    <template v-slot:reportForm>
      <report-field :field-name="$tc('Workspace', 1)">
        <treeselect
          v-model="selectedWorkspace"
          :options="workspaceOptions"
          :disabled="
            !hasPermissionToCreateExport ||
              workspaceSelectionDisabled ||
              !userHasManagementPermission('workspace', 'list')
          "
          disableFuzzyMatching
        />
      </report-field>
      <!--      <report-field :field-name="$t(reportParameters[0].label)">
        <treeselect
          v-model="reportParameters[0].value"
          :options="networkStartingPointOptions"
          :disabled="
            !hasPermissionToCreateExport ||
              technicalSiteLocalDisabled ||
              !userHasPermissionToList('technical_local')
          "
          :disable-branch-nodes="true"
          disableFuzzyMatching
        />
      </report-field>-->
      <report-field :field-name="$tc(reportParameters[0].label, 1)">
        <treeselect
          v-model="reportParameters[0].value"
          :options="manholeOptions"
          :multiple="true"
          value-consists-of="LEAF_PRIORITY"
          :default-expand-level="1"
          :disabled="
            !hasPermissionToCreateExport ||
              manholeFieldDisabled ||
              !userHasPermissionToList('technical_point')
          "
          disableFuzzyMatching
        />
      </report-field>
    </template>
  </report-page>
</template>

<script>
import ReportPage from "../ReportPage";
import ReportField from "../ReportField";
import { homeReportPageMixin } from "@/mixins/homeReportPageMixin";

export default {
  name: "MasksReport",

  components: {
    ReportField,
    ReportPage
  },

  mixins: [homeReportPageMixin],
  props: {
    name: {
      type: String,
      required: true
    },
    version: {
      type: String
    }
  },

  data() {
    return {
      reportParameters: [
        /*        {
          label: "NetworkStartingPoint",
          key: "technical_point",
          type: "text",
          value: undefined
        }*/
        {
          label: "Manhole",
          key: "manhole",
          type: "text",
          value: undefined
        }
      ],

      historyFilter: "masks",

      manholeOptions: []
    };
  },

  computed: {
    buttonsDisabled() {
      return this.reportParameters[0].value === undefined;
    },
    manholeFieldDisabled() {
      return this.selectedWorkspace === undefined;
    },
    dataToSend() {
      return {
        type: this.historyFilter,
        version: this.version,
        objects: {
          workspace_uuid: this.selectedWorkspace,
          object: {
            uuid: this.reportParameters[0].value,
            object_type: this.reportParameters[0].key
          }
        }
      };
    }
  },

  mounted() {
    this.setWorkspaceField();
  },

  methods: {
    loadManholeOptions() {
      this.$store
        .dispatch("GET_ALL_OBJECTS_IN_GIVEN_WORKSPACE", {
          endpoint: "technicalpoints",
          workspaceUUID: this.selectedWorkspace,
          technicalType: "fc_manhole"
        })
        .then(manholes => {
          let manholeOptions = this.optionListNormalizer(manholes, "tp");
          this.manholeOptions = this.includeInAllOption(manholeOptions);
        })
        .catch(error => console.log(error));
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Home/Content/Tabs/Reports/ReportsPages/Masks.vue